/* ============================================
   NIMBA FOODS — PRODUCT DETAIL PAGE JS
   Gallery, Bundle Selector, Qty, Sticky ATC, Accordion
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a, h2, p').forEach(el => {
    if (el.textContent.includes('First Jar')) {
      el.textContent = el.textContent.replace(/First Jar/g, 'First Order');
    }
    if (el.textContent.includes('first jar')) {
      el.innerHTML = el.innerHTML.replace(/first jar/g, 'first order');
    }
  });

  const isRawPdp = /\/products\/raw-african-shea-butter/.test(window.location.pathname) || /product-raw\.html$/.test(window.location.pathname);

  function getRawBundleState() {
    const selected = document.querySelector('.pd-bundle__card--selected');
    if (!selected) return null;
    const labelEl = selected.querySelector('.pd-bundle__label');
    const bundleName = labelEl ? labelEl.childNodes[0].textContent.trim() : '';
    return {
      bundle_name: bundleName,
      bundle_qty: parseInt(selected.dataset.weight || selected.dataset.qty || '1', 10),
      price: selected.dataset.price || '',
      qty: parseInt(document.getElementById('pdQty')?.value || '1', 10)
    };
  }

  // ============ 1. GALLERY THUMBNAILS ============
  const mainImg = document.getElementById('pdMainImg');
  const mainWrap = document.getElementById('pdMainWrap');
  const thumbs = document.querySelectorAll('.pd-gallery__thumb');

  if (mainImg && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        // Remove active from all
        thumbs.forEach(t => t.classList.remove('pd-gallery__thumb--active'));
        thumb.classList.add('pd-gallery__thumb--active');

        const isVideo = thumb.dataset.video;
        if (isVideo) {
          // Replace main image with video
          const existing = mainWrap.querySelector('.pd-gallery__main-video');
          if (existing) existing.remove();
          mainImg.style.display = 'none';
          const video = document.createElement('video');
          video.className = 'pd-gallery__main-video';
          video.src = isVideo;
          video.autoplay = true;
          video.loop = true;
          video.muted = true;
          video.playsInline = true;
          video.controls = true;
          video.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:var(--radius-lg, 16px);';
          mainWrap.appendChild(video);
        } else {
          // Swap to image
          const existingVid = mainWrap.querySelector('.pd-gallery__main-video');
          if (existingVid) existingVid.remove();
          mainImg.style.display = 'block';
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.alt || '';
        }
      });
    });

    // Desktop hover zoom
    if (window.matchMedia('(hover: hover)').matches) {
      mainWrap.addEventListener('mousemove', (e) => {
        const img = mainWrap.querySelector('#pdMainImg');
        if (!img || img.style.display === 'none') return;
        const rect = mainWrap.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = 'scale(1.6)';
      });
      mainWrap.addEventListener('mouseleave', () => {
        const img = mainWrap.querySelector('#pdMainImg');
        if (img) img.style.transform = 'scale(1)';
      });
    }

    // Lightbox on click
    mainWrap.addEventListener('click', () => {
      const src = mainImg.src;
      const lightbox = document.getElementById('pdLightbox');
      const lbImg = document.getElementById('pdLightboxImg');
      if (lightbox && lbImg) {
        lbImg.src = src;
        lightbox.classList.add('pd-lightbox--open');
        document.body.style.overflow = 'hidden';
      }
    });

    const lightbox = document.getElementById('pdLightbox');
    if (lightbox) {
      lightbox.querySelector('.pd-lightbox__close').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeLightbox();
      });
    }
    function closeLightbox() {
      const lb = document.getElementById('pdLightbox');
      if (lb) {
        lb.classList.remove('pd-lightbox--open');
        document.body.style.overflow = '';
      }
    }
  }

  // ============ 2. MOBILE GALLERY DOTS ============
  const mobileGallery = document.querySelector('.pd-gallery__mobile-scroll');
  const dots = document.querySelectorAll('.pd-gallery__dot');
  if (mobileGallery && dots.length) {
    mobileGallery.addEventListener('scroll', () => {
      const scrollLeft = mobileGallery.scrollLeft;
      const width = mobileGallery.offsetWidth;
      const index = Math.round(scrollLeft / width);
      dots.forEach((d, i) => d.classList.toggle('pd-gallery__dot--active', i === index));
    }, { passive: true });
  }

  // ============ 3. BUNDLE SELECTOR ============
  const bundleCards = document.querySelectorAll('.pd-bundle__card');
  const priceCompare = document.getElementById('pdPriceCompare');
  const priceCurrent = document.getElementById('pdPriceCurrent');
  const priceSave = document.getElementById('pdPriceSave');
  const atcBtn = document.getElementById('pdAtcBtn');
  const atcBtnSticky = document.getElementById('pdAtcBtnSticky');
  const stickyPrice = document.getElementById('pdStickyPrice');
  const stickyBundle = document.getElementById('pdStickyBundle');
  const qtyInput = document.getElementById('pdQty');
  let subscribeToggle = document.querySelector('[data-subscribe-toggle]');
  let sellingPlanSelect = document.querySelector('[data-selling-plan-select]');
  let purchaseWidget = document.querySelector('[data-subscribe-widget]');
  let oneTimeOption = document.querySelector('[data-one-time-option]');
  let subscribeOption = document.querySelector('[data-subscribe-option]');
  let subscribePriceEl = document.querySelector('[data-subscribe-price]');

  function ensurePurchaseOptions() {
    if (!purchaseWidget || oneTimeOption || !subscribeToggle || !sellingPlanSelect) return;

    const selected = document.querySelector('.pd-bundle__card--selected');
    const price = parseFloat(selected?.dataset.price || '0');
    const option = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
    const discount = parseFloat(option?.dataset.discount || option?.textContent.match(/(\d+(?:\.\d+)?)%\s*off/i)?.[1] || '15');
    const subscriptionPrice = price > 0 ? price * (1 - discount / 100) : 0;
    const oldLabel = subscribeToggle.closest('.pd-subscribe__label');
    const purchaseOptions = document.createElement('div');
    purchaseOptions.className = 'pd-purchase-options';
    purchaseOptions.setAttribute('aria-label', 'Purchase options');
    purchaseOptions.dataset.purchaseOptionsVersion = '2026-05-06';
    purchaseOptions.innerHTML = `
      <button type="button" class="pd-purchase-option pd-purchase-option--active" data-one-time-option>
        <span class="pd-purchase-option__radio" aria-hidden="true"></span>
        <span class="pd-purchase-option__copy">
          <strong>One-time purchase</strong>
          <small>Same everyday price as Amazon</small>
        </span>
        <span class="pd-purchase-option__price">${price > 0 ? `$${price.toFixed(2)}` : ''}</span>
      </button>
      <label class="pd-purchase-option pd-purchase-option--subscribe" data-subscribe-option>
        <input type="checkbox" data-subscribe-toggle ${subscribeToggle.checked ? 'checked' : ''}>
        <span class="pd-purchase-option__radio" aria-hidden="true"></span>
        <span class="pd-purchase-option__copy">
          <strong>Never run out of raw shea</strong>
          <small>Subscribe &amp; Save ${Number.isFinite(discount) ? discount : 15}% for your next batch</small>
        </span>
        <span class="pd-purchase-option__price" data-subscribe-price>${subscriptionPrice > 0 ? `$${subscriptionPrice.toFixed(2)}` : ''}</span>
      </label>
    `;

    purchaseWidget.insertBefore(purchaseOptions, sellingPlanSelect);
    oldLabel?.remove();
    subscribeToggle = purchaseWidget.querySelector('[data-subscribe-toggle]');
    oneTimeOption = purchaseWidget.querySelector('[data-one-time-option]');
    subscribeOption = purchaseWidget.querySelector('[data-subscribe-option]');
    subscribePriceEl = purchaseWidget.querySelector('[data-subscribe-price]');
    sellingPlanSelect.disabled = !subscribeToggle?.checked;
  }

  ensurePurchaseOptions();

  function getSubscriptionDiscount() {
    if (!subscribeToggle?.checked || !sellingPlanSelect?.value) return 0;
    const option = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
    const discount = parseFloat(option?.dataset.discount || option?.textContent.match(/(\d+(?:\.\d+)?)%\s*off/i)?.[1] || '0');
    return Number.isFinite(discount) ? discount : 0;
  }

  function setPurchaseOptionState() {
    const isSubscription = !!subscribeToggle?.checked;
    oneTimeOption?.classList.toggle('pd-purchase-option--active', !isSubscription);
    subscribeOption?.classList.toggle('pd-purchase-option--active', isSubscription);
    purchaseWidget?.classList.toggle('pd-subscribe--active', isSubscription);
  }

  function updatePrices() {
    const selected = document.querySelector('.pd-bundle__card--selected');
    if (!selected) return;

    const compare = parseFloat(selected.dataset.compare);
    const price = parseFloat(selected.dataset.price);
    const savePercent = selected.dataset.save;
    const available = selected.dataset.available !== 'false';
    const qty = parseInt(qtyInput?.value || '1');
    const subscriptionDiscount = getSubscriptionDiscount();
    const displayPrice = subscriptionDiscount > 0 ? price * (1 - subscriptionDiscount / 100) : price;
    const displayCompare = subscriptionDiscount > 0 ? price : compare;
    if (subscribePriceEl) {
      const subscribePrice = price * (1 - (subscriptionDiscount || 15) / 100);
      subscribePriceEl.textContent = `$${subscribePrice.toFixed(2)}`;
    }
    const totalCompare = (displayCompare * qty).toFixed(2);
    const totalPrice = (displayPrice * qty).toFixed(2);

    if (priceCompare) {
      priceCompare.textContent = displayCompare > displayPrice ? `$${totalCompare}` : '';
      priceCompare.style.display = displayCompare > displayPrice ? '' : 'none';
    }
    if (priceCurrent) priceCurrent.textContent = `$${totalPrice}`;
    if (priceSave) priceSave.textContent = subscriptionDiscount > 0 ? `Subscribe & Save ${subscriptionDiscount}%` : (compare > price ? `Save ${savePercent}` : '');
    if (atcBtn) {
      atcBtn.textContent = available ? `Add to Cart — $${totalPrice}` : 'Sold Out';
      atcBtn.disabled = !available;
    }
    if (atcBtnSticky) {
      atcBtnSticky.textContent = available ? `Add to Cart — $${totalPrice}` : 'Sold Out';
      atcBtnSticky.disabled = !available;
    }
    if (stickyPrice) stickyPrice.textContent = `$${totalPrice}`;
    if (stickyBundle) {
      // Extract the first text node from the bundle label (the name, not the sub-text)
      const labelEl = selected.querySelector('.pd-bundle__label');
      if (labelEl) {
        const name = labelEl.childNodes[0].textContent.trim();
        const sub = labelEl.querySelector('.pd-bundle__per-unit')?.textContent.trim().split('·')[0].trim();
        stickyBundle.textContent = sub ? `${name} — ${sub}` : name;
      }
    }

    // Dynamic shipping message
    const shippingMsg = document.getElementById('pdShippingMsg');
    if (shippingMsg) {
      const bundleQty = parseInt(selected.dataset.weight || selected.dataset.tins || selected.dataset.qty || '1');
      if (bundleQty >= 2) {
        shippingMsg.textContent = '\u2713 This option qualifies for free shipping';
      } else {
        shippingMsg.textContent = 'Free shipping on 2+ pouches';
      }
    }
  }

  if (subscribeToggle && sellingPlanSelect) {
    subscribeToggle.addEventListener('change', () => {
      sellingPlanSelect.disabled = !subscribeToggle.checked;
      setPurchaseOptionState();
      updatePrices();
      if (typeof window.ntrack === 'function') {
        window.ntrack('pdp_subscribe_toggle', {
          subscribed: subscribeToggle.checked,
          selling_plan: subscribeToggle.checked ? sellingPlanSelect.value : ''
        });
      }
    });
    sellingPlanSelect.addEventListener('change', updatePrices);
    oneTimeOption?.addEventListener('click', () => {
      subscribeToggle.checked = false;
      sellingPlanSelect.disabled = true;
      setPurchaseOptionState();
      updatePrices();
    });
  }

  bundleCards.forEach(card => {
    card.addEventListener('click', () => {
      bundleCards.forEach(c => c.classList.remove('pd-bundle__card--selected'));
      card.classList.add('pd-bundle__card--selected');
      // Reset qty to 1 on bundle change
      if (qtyInput) qtyInput.value = '1';
      updatePrices();
      if (isRawPdp && typeof window.ntrack === 'function') {
        const state = getRawBundleState();
        if (state) window.ntrack('pdp_raw_bundle_select', state);
      }
    });
  });

  // ============ 4. QUANTITY +/- ============
  const qtyMinus = document.getElementById('pdQtyMinus');
  const qtyPlus = document.getElementById('pdQtyPlus');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const val = parseInt(qtyInput.value);
      if (val > 1) {
        qtyInput.value = val - 1;
        updatePrices();
        if (isRawPdp && typeof window.ntrack === 'function') {
          window.ntrack('pdp_raw_qty_change', { qty: parseInt(qtyInput.value, 10) });
        }
      }
    });
    qtyPlus.addEventListener('click', () => {
      const val = parseInt(qtyInput.value);
      if (val < 10) {
        qtyInput.value = val + 1;
        updatePrices();
        if (isRawPdp && typeof window.ntrack === 'function') {
          window.ntrack('pdp_raw_qty_change', { qty: parseInt(qtyInput.value, 10) });
        }
      }
    });
  }

  if (isRawPdp && typeof window.ntrack === 'function') {
    if (atcBtn) {
      atcBtn.addEventListener('click', () => {
        const state = getRawBundleState();
        if (state) window.ntrack('pdp_raw_add_to_cart', state);
      });
    }
    if (atcBtnSticky) {
      atcBtnSticky.addEventListener('click', () => {
        const state = getRawBundleState();
        if (state) window.ntrack('pdp_raw_sticky_add_to_cart', state);
      });
    }
  }

  // ============ 5. STICKY ATC BAR ============
  const stickyBar = document.getElementById('pdStickyBar');
  const mainAtcSection = document.getElementById('pdAtcBtn');

  if (stickyBar && mainAtcSection) {
    let hasScrolled = false;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) hasScrolled = true;
    }, { passive: true });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || !hasScrolled) {
          stickyBar.classList.remove('pd-sticky--visible');
        } else {
          stickyBar.classList.add('pd-sticky--visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(mainAtcSection);
  }

  // ============ 6. ACCORDION ============
  const accordionItems = document.querySelectorAll('.pd-details__trigger');
  accordionItems.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.parentElement;
      const isOpen = item.classList.contains('pd-details__item--open');

      // Close all
      document.querySelectorAll('.pd-details__item--open').forEach(openItem => {
        openItem.classList.remove('pd-details__item--open');
        openItem.querySelector('.pd-details__trigger').setAttribute('aria-expanded', 'false');
      });

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('pd-details__item--open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ============ BEFORE/AFTER SLIDER ============
  const baSlider = document.getElementById('pdBaSlider');
  const baHandle = document.getElementById('pdBaHandle');
  if (baSlider && baHandle) {
    let isDragging = false;

    function updateBaSlider(clientX) {
      const rect = baSlider.getBoundingClientRect();
      let x = (clientX - rect.left) / rect.width;
      x = Math.max(0.05, Math.min(0.95, x));
      const pct = x * 100;
      baSlider.querySelector('.pd-ba__before').style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      baHandle.style.left = pct + '%';
    }

    baSlider.addEventListener('mousedown', (e) => {
      isDragging = true;
      updateBaSlider(e.clientX);
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (isDragging) updateBaSlider(e.clientX);
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    // Touch support
    baSlider.addEventListener('touchstart', (e) => {
      isDragging = true;
      updateBaSlider(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('touchmove', (e) => {
      if (isDragging) updateBaSlider(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  // ============ IMPACT NUMBER COUNTER ============
  const impactNumbers = document.querySelectorAll('.pd-impact__number[data-target]');
  if (impactNumbers.length) {
    const impactObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseFloat(el.dataset.target);
          const suffix = el.dataset.suffix || '';
          const duration = 2000;
          const start = performance.now();
          const isDecimal = target % 1 !== 0;

          function animate(now) {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            // Ease out cubic
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = eased * target;
            el.textContent = (isDecimal ? current.toFixed(1) : Math.round(current).toLocaleString()) + suffix;
            if (progress < 1) requestAnimationFrame(animate);
          }
          requestAnimationFrame(animate);
          impactObserver.unobserve(el);
        }
      });
    }, { threshold: 0.3 });

    impactNumbers.forEach(el => impactObserver.observe(el));
  }

  // ============ UGC VIDEO AUTOPLAY ============
  const ugcAutoplayObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.sb-ugc__thumb').forEach(video => {
    ugcAutoplayObserver.observe(video);
  });

  // ============ CROSS-SELL VIDEO AUTOPLAY ============
  const watchbuyAutoplayObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.pd-watchbuy__video-thumb video').forEach(video => {
    watchbuyAutoplayObserver.observe(video);
  });

  // ============ SCROLL REVEAL (lightweight, no GSAP dependency) ============
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('pd-revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.pd-reveal').forEach(el => revealObserver.observe(el));
});
